module.exports = __webpack_public_path__ + "img/angular.1f533d2f.jpg";